export default function(h, row, index) {
    let s1 = ''
    let s2 = ''

    if ( (row.email_correct && row.email_correct!==null) || (row.email && row.email!==null) ) {
        if ((row.email_correct === row.email) || (!row.email) || (row.email === null))
            s1 = <span class="orders_table__contacts">{row.email_correct}</span>
        else
            s1 = <span><span class="orders_table__contacts">{row.email_correct}</span><br/><span class="orders_table__contacts">({row.email})</span></span>
    }

    if ( (row.phones_correct && row.phones_correct!==null) || (row.phones && row.phones!==null) ) {
        if ((row.phones_correct === row.phones)|| (!row.phones) || (row.phones === null))
            s2 = <span class="orders_table__contacts">{row.phones_correct}</span>
        else
            s2 = <span><span class="orders_table__contacts">{row.phones_correct}</span><br/><span class="orders_table__contacts_old">({row.phones})</span></span>
    }

    if (s1 && s2)
        return <span>{s1}<br/>{s2}</span>
    if (s1)
        return <span>{s1}</span>
    if (s2)
        return <span>{s2}</span>

}